import React from 'react';

const Loading = () => {
  return (
    <div className="loading">
      <div className="spinner"></div>
      <p>Lädt...</p>
    </div>
  );
};

export default Loading;
